/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-26 15:52:27
 * @LastEditors: K
 * @LastEditTime: 2022-09-09 13:52:54
 */

import { getOrganizationPlaneName } from './monitoring'

// 饼状图
export const echartsPie: any = (
  listData: any,
  name: string,
  value: string,
  title?: boolean,
  titleStr?: string
) => {
  const tempArr = listData?.map((item: any) => {
    return {
      value: item[value],
      name: item[name],
    }
  })
  
  const option = {
    width: '100%',
    title: title
      ? {
          text: titleStr && getOrganizationPlaneName(titleStr),
          left: 'left',
        }
      : undefined,
    tooltip: {
      trigger: 'item',
    },
    legend: {
      orient: 'vertical',
      left: 'left',
      top: '40',
    },
    series: [
      {
        type: 'pie',
        radius: '50%',
        width: '100%',
        left: '60',
        top: '20',
        data: tempArr,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ] ,
  }
  
  return option
}

// 折线图
export const echartsLine: any = (
  listData: any,
  titletype: boolean,
  title: string,
  legendNum: number,
  
 
) => {
  
  const tempArr = optionsLegendName(legendNum).map(
    (t: any) => {
      return {
        name: t.name,
        type: 'line',
        smooth: true,
        data: listData?.tendencyChartTDetailVO?.map((item: any) => {
          return Number(
            item?.sysTendencyChartList
              .filter((obj: any) => obj.curveType == t.value)
              .map((val: any) => val.val)
          )
        }),
      }
    }
  )
  
  const option = {
    title: {
      text: titletype ? getOrganizationPlaneName(title) : '',
    },
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      data: optionsLegendName(legendNum).map((item: any) => item.name),
    },
    grid: {
      // width: '100%',
      left: '3%',
      right: '3%',
      bottom: 0,
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: listData?.month?.map((item: any) => item + '月'),
      axisLabel: {
        showMaxLabel: true,
      },
    },
    yAxis: {
      type: 'value',
    },
    series: tempArr,
  }
  return option
}
// 柱状图
export const echartBre: any = (
  listData: any,
  legendNum: number,
  title: string
) => {
  
  const tempArr = optionsLegendName(legendNum).map(
    (t: any) => {
      return {
        name: t.name,
        type: 'bar',
        stack: 'Ad',
        emphasis: {
          focus: 'series'
        },
        data: listData?.tendencyChartTDetailVO?.map((item: any) => {
          return Number(
            item?.sysTendencyChartList
              .filter((obj: any) => obj.curveType == t.value)
              .map((val: any) => val.val)
          )
        }),
         
      }
    }
  )
  
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    title: {
      text: getOrganizationPlaneName(title),
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: listData?.month?.map((item: any) => item + '月')
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: tempArr
  };
  return option
}



export enum optionsLegend {
  JG = 0, //机构数据
  YS = 1, //医生数据
  MZ = 2, //门诊数据
  BL = 3, //病历数据
  JS = 4, //结算数据
  FWJG = 5, //服务机构数据
  FWBS = 6,  //服务机构笔数
  YYJE = 7, //服务运营数据
  YYBS = 8, //服务运营数据
  CPZX = 9, //服务运营数据
}
export const optionsLegends = [
  optionsLegend.JG, 
  optionsLegend.YS, 
  optionsLegend.MZ,
  optionsLegend.FWJG,
  optionsLegend.FWBS,
  optionsLegend.YYJE,
  optionsLegend.YYBS,
  optionsLegend.CPZX,
  optionsLegend.BL,
  optionsLegend.JS,
]

export function optionsLegendName(optionsLegend: optionsLegend): any[] {
  switch (optionsLegend) {
    case 0:
      return [
        { name: '机构总数', value: 0 },
        { name: '活跃机构数', value: 1 },
        { name: '医保机构数', value: 2 },
        { name: '非医保机构数', value: 3 },
        { name: '聚网机构数', value: 4 },
        { name: '好医点机构数', value: 5 },
        { name: '新增机构数', value: 6 },
      ]
    case 1:
      return [
        { name: '医生总数', value: 7 },
        { name: '活跃医生数', value: 8 },
      ]
    case 2:
      return [
        { name: '患者总数', value: 9 },
        { name: '门诊次数', value: 10 },
        { name: '结算次数', value: 11 },
      ]
    case 3:
      return [
        { name: '通用病历', value: 12 },
        { name: '中医病历', value: 13 },
        { name: '口腔病历', value: 14 },
        { name: '医美病历', value: 15 },
      ]
    case 4:
      return [
        { name: '西药方', value: 16 },
        { name: '中药方', value: 17 },
        { name: '颗粒草药方', value: 18 },
        { name: '治疗', value: 19 },
        { name: '检查', value: 20 },
        { name: '处置项目', value: 21 },
        { name: '其他', value: 22 },
        { name: '零售开单', value: 23 },
        { name: '挂号', value: 24 },
      ]
    case 5:
      return [
        { name: '增值医保笔数', value: 25 },
        { name: '增值聚合支付笔数', value: 26 },
        { name: '增值委外代煎笔数', value: 27 },
        { name: '增值电子发票笔数', value: 28 },
        { name: '增值短信包笔数', value: 29 },
        { name: '付费笔数', value: 30 },
      ]
    case 6:
      return [
        { name: '增值医保开通机构', value: 31 },
        { name: '增值聚合支付开通机构', value: 32 },
        { name: '增值委外代煎开通机构', value: 33 },
        { name: '增值电子发票开通机构', value: 34 },
        { name: '增值短信包开通机构', value: 35 },
        { name: '付费开通机构', value: 36 },
      ]
    case 7:
      return [
        {name: '医保总额', value: 37},
        {name: '聚合支付总额', value: 38},
        {name: '委外代煎总额', value: 39},
        {name: '电子发票总额', value: 40},
        {name: '短信总额', value: 41},
        {name: '续订总额', value: 42}
      ]
    case 8:
      return [
        {name: '医保总额笔数', value: 43},
        {name: '聚合支付总额笔数', value: 44},
        {name: '委外代煎总额笔数', value: 45},
        {name: '电子发票总额笔数', value: 46},
        {name: '短信总额笔数', value: 47},
        {name: '续订总额笔数', value: 48}
      ]
    case 9:
      return [
        {name: '咨询数', value: 49},
        {name: '销售笔数', value: 50},
      ]

    default:
      return ['']
  }
}
